module.exports = __webpack_public_path__ + "images/d298461cd9102a3b74a9953a0d6d77ee-IMG_8213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/IMG_8213.jpg
// module id = ./src/assets/images/slides/home/IMG_8213.jpg
// module chunks = 0